import { useEffect } from "react";

/**
 * Inject a JSON-LD <script> into <head> for the duration of the component.
 * Pass `null` to skip injection (e.g. while data is loading).
 */
export function useJsonLd(data: Record<string, any> | null | undefined, id?: string) {
  useEffect(() => {
    if (!data) return;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    if (id) script.dataset.jsonldId = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, [JSON.stringify(data), id]);
}
